// this file is automatically generated by git-version.js script
export const version = { revision: '927db69', version: '4.2.3' };
